import Link from "next/link"
import Stack from "@mui/material/Stack"
import { LinkProps } from "@mui/material/Link"
import { MAX_FILTER_SHOW } from "./FilterType"
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useMemo, useState } from "react";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import dynamic from "next/dynamic";
import { useLayoutData } from "../../../../utils/contexts/LayoutContext";
import { FindButtonProps } from "../FindDesignTypes";
import FindFilterMobileListItem from "../FindFilterMobileListItem";
import { filterUrl } from "../Find";
import { PageType } from "../../../../pages/_app";
import { FilterOptionsProps } from "../Find.types";
import { ResultFilterItemModel, ResultFilterModel } from "../../../../client/swaggerClient";

const getUrl = (
	filters: ResultFilterModel,
	item: ResultFilterItemModel,
	pageUrl?: string,
	mmbr?: string | string[],
) => {
	let list = filters.items?.filter((i) => i.selected).map((i) => i.targetUrlListItem)

	if (item.selected) {
		list = list?.filter((i) => i !== item.targetUrlListItem)
	} else {
		list = list ? [...list, item.targetUrlListItem] : [item.targetUrlListItem]
	}

	const url = list && list.length > 0 ? filters.targetUrl?.replace('(list)', list?.join(',')) : filters.resetUrl

	return filterUrl(filters, undefined, url, pageUrl, mmbr)
}

const FilterOptionsMultiselect = ({
  filters,
  colors,
  pageUrl,
  mmbr,
  isMobile,
  closeSubmenu
}: FilterOptionsProps) => {
  const { partnerSiteFull, templatePath } = useLayoutData()

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindButton = useMemo(() => dynamic<FindButtonProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindButton)), [path])
  const FindExpandLink = useMemo(() => dynamic<LinkProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindExpandLink)), [path])

  const [showAll, setShowAll] = useState<boolean>(false);
  const length = filters?.items && filters?.items?.length > MAX_FILTER_SHOW ? MAX_FILTER_SHOW : filters?.items?.length
  const maxLength = showAll ? filters?.items?.length : length
  
  return (
    <>
      {isMobile ? (
        <>
          {filters?.items?.map((item, i) => (
              <FindFilterMobileListItem
                key={i}
                filters={filters}
                item={item}
                multiSelect={true}
                colors={colors}
                pageUrl={getUrl(filters, item, pageUrl, mmbr)}
                mmbr={mmbr}
                closeSubmenu={closeSubmenu}
              />
            )
          )}
        </>
      ) : (
        <>
          {filters?.items?.slice(0, maxLength).map((item, i) => {
            return item.disabled ? (
              <FindButton
                bgcolor={colors.mainColor}
                bghovercolor={colors.secondaryColor}
                variant="outlined"
                filterbutton={1}
                selected={item?.selected ? 1 : 0}
                multiselect={1}
                startIcon={
                  item.selected ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />
                }
                aria-label={item.title}
              >
                {item.title}
                <span>({item.count})</span>
              </FindButton>
            ) : (
              <Link key={i} href={getUrl(filters, item, pageUrl, mmbr)} scroll={false} passHref>
                <a>
                  <FindButton 
                    bgcolor={colors.mainColor}
                    bghovercolor={colors.secondaryColor}
                    variant="outlined"
                    filterbutton={1}
                    selected={item?.selected ? 1 : 0}
                    multiselect={1}
                    startIcon={
                      item.selected ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />
                    }
                    aria-label={item.title}
                  >
                    {item.title}
                    <span>({item.count})</span>
                  </FindButton>
                </a>
              </Link>
            )
          })}
          {filters?.items && filters?.items?.length > MAX_FILTER_SHOW ? (
            <FindExpandLink onClick={() => setShowAll(!showAll)}>
              <Stack display={"inline-flex"} flexDirection={"row"} alignItems={"center"}>
                <Stack mr={1}>{showAll ? <CloseFullscreenIcon /> : <OpenInFullIcon />}</Stack>
                <Stack>{showAll ? "Mutass kevesebbet" : "Mutasd mindet"}</Stack>            
              </Stack>
            </FindExpandLink>
          ) : null}
        </>
      )}
    </>
  )
}

export default FilterOptionsMultiselect